import {GET_PIXABAYVIDEO,CLOSE_PIXABAYVIDEO} from '../actions/actionTypes'

export default (state = {data:{}}, action) => {
    switch (action.type) {

        case GET_PIXABAYVIDEO:
            // console.log(action.payload);
            return action.payload;

        case CLOSE_PIXABAYVIDEO:
            // console.log(action.payload);
            return {data:{}};

        default:
            return state;
    }
};